import { useQuery } from "@tanstack/react-query";
import { getExtractions } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

export const getExtractionsQueryKey = (offset: number, limit: number, searchQuery?: string) => [
	"EXTRACTIONS_QUERY",
	offset,
	limit,
	searchQuery,
];

export function useExtractionsQuery(offset = 0, limit = 100, searchQuery?: string) {
	return useQuery({
		queryKey: getExtractionsQueryKey(offset, limit, searchQuery),
		queryFn: processResponse(() => getExtractions(offset, limit, searchQuery || null)),
	});
}
